import { MouseEvent } from "react";
import { Button, Tooltip } from "@shared/ui";
import { Star, StarOff } from "lucide-react";
import { useShortlistInfluencerV2 } from "@entities/brief/lib/hooks/useShortlistInfluencerV2";
import { useUnshortlistInfluencersV2 } from "@entities/brief/lib/hooks/useUnshortlistInfluencersV2";
import { useBriefStore } from "@pages/layout/BriefLayout/lib/useLayoutStore";
import styles from "./styles.module.scss";

type ShortlistCreatorButtonProps = {
  briefInfluencerId: string;
  mode: "shortlist" | "unshortlist";
};

export function ShortlistCreatorButton({
  briefInfluencerId,
  mode,
}: ShortlistCreatorButtonProps) {
  const { briefId } = useBriefStore();
  const { shortlistInfluencer, isShortlisting } =
    useShortlistInfluencerV2(briefId);
  const { unshortlistInfluencers, isUnshortlisting } =
    useUnshortlistInfluencersV2(briefId);

  const isUnshortlist = mode === "unshortlist";
  const isLoading = isShortlisting || isUnshortlisting;

  const handleClick = (event: MouseEvent) => {
    event.stopPropagation();
    if (!briefInfluencerId || isLoading) return;
    if (isUnshortlist) {
      unshortlistInfluencers(briefInfluencerId);
      return;
    }
    shortlistInfluencer(briefInfluencerId);
  };

  return (
    <Tooltip
      title={isUnshortlist ? "Remove from shortlist" : "Add to shortlist"}
    >
      <Button
        type="default"
        size="small"
        loading={isLoading}
        onClick={handleClick}
        className={
          isUnshortlist ? styles.unshortlistButton : styles.shortlistButton
        }
        icon={isUnshortlist ? <StarOff size={12} /> : <Star size={12} />}
      >
        {isUnshortlist ? "Unshortlist" : "Shortlist"}
      </Button>
    </Tooltip>
  );
}
